import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  loadingValidation: false,
  chosenSPEmployeeId: null,
  currentSPEmployee: {},
  spEmployeeBeforeEdit: {},
  serviceProvidersOfCompanyList: [],
  serviceProviderCompanyFullRegionsOptions: [],
  serviceProviderCompanyFullRegionsOptionsLoading: null,
  serviceProviderCompanyFullRegionsOptionsLoadingErrors: null,
  serviceProviderCompanyFullServicesOptions: [],
  serviceProviderCompanyFullServicesOptionsLoading: null,
  serviceProviderCompanyFullServicesOptionsLoadingErrors: null,
  serviceProviderFreelancerProfileDetails: {},
  serviceProviderCompanyProfileDetails: {},
  serviceProviderWorkerProfileDetails: {},
  companyCustomerProfileDetails: {},
  companyCustomerFullRegionsOptions: [],
  companyCustomerFullRegionsOptionsLoading: null,
  companyCustomerFullRegionsOptionsLoadingErrors: null,
  companyCustomerFullIndustriesOptions: [],
  companyCustomerFullIndustriesOptionsLoading: null,
  companyCustomerFullIndustriesOptionsLoadingErrors: null,
  companyCustomerFullRegulationsOptions: [],
  companyCustomerFullRegulationsOptionsLoading: null,
  companyCustomerFullRegulationsOptionsLoadingErrors: null,
  customerProfileDetails: {},
  featureToggles: {},
  licenseData: null,
  isServiceProvider: false,
  tenantUsers: [],
  pendingUsers: [],
  domains: [],
  users: [],
  workers: [],
  scan_data: [],
  companyData: {},
  advisedActions: [],
  userListOptions: {
    sort: {
      firstName: 'asc',
    },
    // While we don’t implement lazy loading we have 25 records limit on BE by default.
    // For quick fix we should remove this limit.
    limit: 0,
    roles: String,
  },
  workerListOptions: {
    sort: {
      firstName: 'asc',
    },
    roles: String,
  },
  workerDetails: {},
  systemSettings: {},
  disableDeleteUserButton: [],
  deleteUserLoading: false,
  userDetailsForEdit: {},
  newUserPassword: '',
};

export default {
  state,
  getters,
  mutations,
  actions,
};
